import { defineComponent as _defineComponent } from 'vue'
import { useMasterAccountAccessSelectDivisionStepStore } from "@rmp/id/stores/masterAccountAccess/steps/selectBranch";
import { usePage } from "@rmp/core/composables/usePage";
import RmpMasterAccountAccessApplicationBaseStep
	from "@rmp/id/views/masterAccountAccess/steps/RmpMasterAccountAccessApplicationBaseStep.vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useMasterAccountAccessStore } from "@rmp/id/stores/masterAccountAccess";
import { useI18n } from "vue-i18n-composable";
import { useColors } from "@rmp/core/composables/useColors";
import RmpDivisionsAutocomplete from "@rmp/core/components/fields/RmpDivisionsAutocomplete.vue";
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpAlert from "@rmp/core/components/alerts/RmpAlert.vue";

export interface Props {
	readonly?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpSelectBranchStep',
  props: {
    readonly: { type: Boolean }
  },
  setup(__props: any) {



const { colors } = useColors();

const { tc, t } = useI18n();

const useStore = useMasterAccountAccessSelectDivisionStepStore;
const masterAccountAccessStore = useMasterAccountAccessStore();
const store = useStore();

const {
	formValid,
	branches,
	departments,
	divisionTree,
	selectedDivisionId
} = storeToRefs(store);

const selectedBranchName = computed(() => branches.value.find(b => b.id === selectedDivisionId.value)?.shortName ?? "");

const formattedDepartments = computed(() => {
	return selectedDivisionId.value
		? departments.value.filter((department) => department.parentId === selectedDivisionId.value)
		: [];
});

const form = ref<any>(null);

const { initialized } = usePage({ useStore });

return { __sfc: true,colors, tc, t, useStore, masterAccountAccessStore, store, formValid, branches, departments, divisionTree, selectedDivisionId, selectedBranchName, formattedDepartments, form, initialized, RmpMasterAccountAccessApplicationBaseStep, RmpDivisionsAutocomplete, RmpText, RmpAlert }
}

})